import { useEffect } from "react";
import { SITE_URL, OG_IMAGE } from "@/lib/schedule";

const BASE_DESC =
  "Pop culture, music, relationships, and internet discourse with SHi. Let’s Elaborate on Wednesdays, The Program on Saturdays. Premieres Thursday, December 3, 2026.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight client-side per-route metadata. JS-executing crawlers get the
// route-specific values; static HTML carries the home defaults (see index.html).
export default function Seo({ title, description = BASE_DESC, path = "" }) {
  useEffect(() => {
    const url = SITE_URL + path;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "That’s What SHi Said");
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
    setLink("canonical", url);
  }, [title, description, path]);
  return null;
}
